import { useContextState } from "../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        keyValue: {
            '& .detail-value': {
                '&.MuiTypography-root': {
                    color: colors.color13,
                    fontSize: '45px',
                    lineHeight: 1
                },
            },
            '& .detail-caption': {
                '&.MuiTypography-root': {
                    fontSize: '12px',
                    color: colors.color13,
                },
            }
        },
        description: {
            fontWeight: 'bold'
        },
        answer: {
            color: colors.color19,
            fontWeight: 'bold'
        },
        container: {
            width: '100%',
            height: 'calc(100% - 40px)',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
        },
        header: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'end',
            '& .MuiTypography-root': {
                fontSize: '12px',
                color: colors.color13
            }
        },
        headerArrow: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        title: {
            fontSize: '16px',
            fontWeight: 'bold',
            color: colors.color1
        },
        label: {
            fontSize: '14px',
        },
        boxBorder: {
            borderRadius: '4px',
            border: `1px solid ${colors.color13}`,
            padding: 1
        },
        body: {
            height: '100%',
            width: '430px',
            padding: 3,
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'space-between',
            '& .detail-caption': {
                textAlign: 'center'
            }
        },
        footer: {
            height: '40px',
            width: '100%',
            display:'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        drawer: {
            position: 'fixed',
            top: 0,
            right: 0,
            zIndex: 1000,
            background: colors.color5,
            height: '100vh'
        }
    }
}

export { useStyles }
